import RcSlider from 'rc-slider/lib/Slider';
import styled from 'styled-components';
import DebouncedInput from './DebouncedInput';

const adjustMobileHandlePosition = ({ title, isMobile }) => {
  if (!isMobile) {
    return null;
  }

  const trackPosition =
    title === 'Cash Down' ? 'margin-left: auto;' : 'margin-right: auto';

  return `width: 97% ; ${trackPosition}`;
};

export const Input = styled(DebouncedInput)`
  padding: 6px 6px 6px;
`;

export const Range = styled(RcSlider)`
  && {
    background-color: ${props => props.disabled && 'transparent'};

    & .rc-slider-rail {
      background-color: ${props => props.theme.carvana.gray.light};
      ${props =>
        props.hasIncline &&
        `
        &:after {
          content: '';
          position: absolute;
          right: 0;
          left: 0;
          top: -32px;
          height: 27px;
          background: transparent;
          background: linear-gradient(to right bottom, transparent 49%, ${props.theme.carvana.gray.light} 51%);
        }
        &:before {
          content: '';
          position: absolute;
          top: -5px;
          height: 5px;
          width: 100%;
          background: ${props.theme.carvana.gray.light};
        }
      `}
    }

    & .rc-slider-handle {
      border-width: 3px;
      box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.24);
    }
  }
`;

export const RangeHeader = styled.div.attrs({ 'data-qa': 'range-header' })`
  display: flex;
  flex-direction: row;
  font-size: 14px;
  font-weight: bold;
  justify-content: space-between;
  line-height: 20px;
  margin-bottom: ${({ hasIncline }) => hasIncline && '2rem'};
  text-transform: uppercase;
`;

export const RangeLabels = styled.div`
  color: ${props => props.theme.carvana.gray.dark};
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  margin-top: 0.5rem;
`;

export const RangeWrapper = styled.div`
  display: flex;
  height: 2rem;
  align-items: flex-end;
  ${adjustMobileHandlePosition}
`;

export const Wrapper = styled.div``;
export const InputsWrapper = styled.div.attrs({ 'data-qa': 'inputs-wrapper' })`
  margin-top: -6px;
  line-height: 1.5;
`;
